'use strict';

/**
 * Initializes the carousels
 * @param {Object} nodes - carousel nodes
 * @returns {void}
 */
function initializeCarousels(nodes) {
    for (let i = 0; i < nodes.length; i += 1) {
        var width = $(window).width();
        var isMobile = width < 768;
        var responseSizes = {
            desktop: 5,
            laptop: 4,
            tablet: 3,
            mobile: 2
        };
        if (width > 0 && !isMobile) {
            // Force responsive count for Add to cart dialog
            if ($(nodes[i]).closest('#addedToCartModal').length > 0) {
                responseSizes = {
                    desktop: 2,
                    laptop: 2,
                    tablet: 2,
                    mobile: 2
                };
            }
            $(nodes[i]).not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: responseSizes.desktop,
                slidesToScroll: responseSizes.desktop,
                arrows: !isMobile,
                dots: !!isMobile,

                responsive: [
                    {
                        breakpoint: 1279,
                        settings: {
                            slidesToShow: responseSizes.laptop,
                            slidesToScroll: responseSizes.laptop
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: responseSizes.tablet,
                            slidesToScroll: responseSizes.tablet
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: responseSizes.mobile,
                            slidesToScroll: responseSizes.mobile
                        }
                    }
                ]
            });
        }
    }
}

module.exports = {
    initializeCarousels: initializeCarousels
};
